import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faPencilAlt, faTrashAlt, faEdit,faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { connect } from 'react-redux';
import { css } from "@emotion/core";
import FadeLoader from "react-spinners/FadeLoader";
import ReactTooltip from "react-tooltip";
const override = css`
  display: block;
  top:50%;
  margin: 0 auto;
  border-color: red;
`;

class OrganizationModule extends Component {  
    
    constructor(props) {
        super(props)

        var curr = new Date();
        curr.setDate(curr.getDate());
        var todaydate = curr.toISOString().substr(0,10);
    
        this.state = {
            Distributorbtn: "Popup_tabButtons",
            DistServbtn: "Popup_tabButtons",
            omOrganiztionList: [],
            omOrgOrganiztionList: [],
            httpURL: this.props.httpURL,
            loginuserObj: this.props.userObj,
            currentDate:todaydate,        
        }
    
    }
    
    componentDidMount() {
        this.getOMOrganiztionList();       
    }
    getOMOrganiztionList() {
        this.setState({
            loading: true
        });
        axios.get(this.state.httpURL + "/webmaster/getOrganizaionList")
            .then(response => response.data)
            .then((data) => {
                if (data.valid) {                    
                    this.setState({
                        omOrganiztionList : data.orgList,
                        omOrgOrganiztionList : data.orgList
                    })
                    ReactTooltip.rebuild();
                } else {
                    alert(data.responseMsg);
                }
                this.setState({
                    loading: false
                });
            }).catch(err => {
                //console.log(err)
                this.setState({
                    loading: false
                });
                alert(err);
            })
    }

    filterList = (event) => {
        let filtered =this.state.omOrgOrganiztionList;
        let inputFields = document.getElementsByClassName('maingrid');
        for (var i = 0; i < inputFields.length; i++) {
            if (inputFields[i].value !== '') {

                var searchString = inputFields[i].value;
                var fieldName = inputFields[i].name; //list object column name

                filtered = filtered.filter(od => (
                   od[fieldName].toLocaleString().toLowerCase().search(searchString.toLowerCase()) !== -1 
                ));
            }
        }
        this.setState({
            omOrganiztionList: filtered
        })
    }
     render() {
        return (
            <div className="O2Container_Wrapper">
                <ReactTooltip/>
                <div className="O2Container_Table">
                    <div className="O2Table_Header"><span>ORGANIZATION</span></div>
                    <div className="Table_wrapper">
                        <table className="customTable" id="organization_Table">
                            <thead>
                                <tr>
                                <th>Organization No
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="ad_org_id" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th>Name
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="name" onChange={this.filterList}/>
                                        </div>
                                    </th>                                    
                                    <th>Description
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="description" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th className="Status_Route">Active
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="isactive" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th className="scroller"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>                                             
                                    {/* <td>2589</td>
                                    <td>Y</td>
                                    <td>2589</td>
                                    <td>Y</td>
                                    <td className="Status_Route">Y</td> */}
                                    {
                                        !this.state.omOrganiztionList || this.state.omOrganiztionList === null || this.state.omOrganiztionList.length === 0 ?
                                        <tr align="center">
                                            <td colSpan="5">No Organization Available</td>
                                        </tr> :
                                        this.state.omOrganiztionList.map((org,i) => (
                                            <tr key={org.id}>                                                                                              
                                                <td data-tip={org.ad_org_id}>{org.ad_org_id}</td>
                                                <td data-tip={org.name}>{org.name}</td>
                                                <td data-tip={org.description}>{org.description}</td>
                                                <td className="Status_Route" data-tip={org.isactive}>{org.isactive}</td>                                                     
                                            </tr>
                                        ))
                                    }
                                </tr> 
                               
                            </tbody>
                        </table>
                    </div>
                    <div className="O2Table_bottomSubContainer">
                        <div className="O2Table_PageCount"><span className="pageCalc_container">Showing<span>{this.state.omOrganiztionList ? this.state.omOrganiztionList.length : 0}</span>entries</span></div>
                        {/* <div className="O2Table_Next"><span className="Nxtprev_btn">Next<FontAwesomeIcon icon={faAngleDoubleRight} style={{ padding: '0px 8px' }} /></span></div>
                        <div className="O2Table_Prev"><span className="Nxtprev_btn"><FontAwesomeIcon icon={faAngleDoubleLeft} style={{ padding: '0px 8px' }} /> Previous</span></div> */}
                    </div>
                    {/* <div className="O2Table_bottomSubContainer">
                        <div className="O2Table_ExpExcel"><FontAwesomeIcon icon={faCloudDownloadAlt} style={{ padding: '0px 8px' }} /></div>
                    </div> */}
                    {/* <div className="O2Table_ExpExcel"><FontAwesomeIcon icon={faCloudDownloadAlt} style={{padding:'0px 8px'}}/><ReactHTMLTableToExcel className="download-table-xls-button" table="organization_Table" filename={"Organization_"+this.state.currentDate}
                        sheet="tablexls" buttonText="Excel Export"/></div> */}
                    {/* <div className="O2Table_Footer">
                        <button>Close</button>
                    </div> */}
                </div>
                <FadeLoader
                    css={override}
                    size={150}
                    color={"#123abc"}
                    loading={this.state.loading}
                />   
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        userObj: state.userObj,
        httpURL: state.httpURL        
    }
}
export default connect(mapStateToProps)(OrganizationModule)
// export default OrganizationModule

